import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'components/libs/zod';
import { createContext, ReactNode, useContext } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { commonErrorMessage } from 'utils/error-message';
import ja from 'utils/ja';

export interface ILoginFormInput {
  username: string;
  password: string;
}

export const loginSchema = z.object({
  username: z
    .string()
    .min(1, commonErrorMessage.MSE00003(ja.login.username.label)),
  password: z
    .string()
    .min(1, commonErrorMessage.MSE00003(ja.login.password.label)),
});

type Schema = z.infer<typeof loginSchema>;

type LoginFormContext = UseFormReturn<Schema>;

const LoginFormContext = createContext<LoginFormContext>(
  {} as LoginFormContext
);

export const useLoginForm = () => useContext(LoginFormContext);
export const LoginFormProvider = ({ children }: { children: ReactNode }) => {
  const form = useForm<Schema>({
    resolver: zodResolver(loginSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      username: '',
      password: '',
    },
  });

  return (
    <LoginFormContext.Provider value={{ ...form }}>
      {children}
    </LoginFormContext.Provider>
  );
};
